// extracted by mini-css-extract-plugin
export default {"Audio3DPlayer":"HoqoET","audio3DPlayer":"HoqoET","first":"OX8SMq","second":"UUGXOr","gradient":"sbcvs4","icon":"GCInyd","mediaButton":"xHUDDa","pausing":"kQd0lP","playing":"QhhmXV"};